import React, { useState } from 'react';

import TeacherComment from 'components/Comment';
import TooltipIconButton from 'components/ToolTipIconButton';
import { DateTime } from 'luxon';

import CommentIcon from '@common/assets/icons/Comment.svg';

interface PropsType {
	comment: string;
	teacherName: string;
	created_at: string;
}

function ProgramsLessonCommentButton({ comment, teacherName, created_at }: PropsType) {
	const [isOpen, setIsOpen] = useState(false);

	const handleToggleToolTip = (e: any) => {
		e?.stopPropagation();

		setIsOpen((open) => !open);
	};

	const formatedDate = DateTime.fromISO(created_at, { zone: 'utc' }).toFormat('MM/dd/yyyy h:mm');

	return (
		<TooltipIconButton
			title={comment && <TeacherComment name={teacherName} date={formatedDate} text={comment} />}
			tooltipProps={{
				open: isOpen,
			}}
			color="success"
			onClick={handleToggleToolTip}
		>
			<CommentIcon />
		</TooltipIconButton>
	);
}

export default ProgramsLessonCommentButton;
